export const { format: formatNOK } = new Intl.NumberFormat('nb-NO', {
  style: 'currency',
  currency: 'NOK',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

export const PRICE_INTERVALS = ['yearly', 'monthly'] as const

export type PriceInterval = typeof PRICE_INTERVALS[number]

export function getExVatPrice(priceIncVat: number, vatPercentage: number) {
  return priceIncVat / (1 + vatPercentage / 100)
}

export interface FormatPriceOptions {
  price: string | number | CrystallizeProductVariant
  interval?: PriceInterval
  taxIncluded?: boolean
}

export function getNumericPrice(options: Omit<FormatPriceOptions, 'interval' | 'style'>) {
  if (typeof options.price === 'number') {
    return options.price
  }
  else if (typeof options.price === 'string') {
    return Number(options.price)
  }
  else if (options.taxIncluded) {
    return options.price.priceVariants.default
  }
  else {
    return getExVatPrice(
      options.price.priceVariants.default,
      options.price.components.effectiveVatPercent ?? 0,
    )
  }
}

export function formatPrice(options: FormatPriceOptions) {
  const formattedPrice = formatNOK(getNumericPrice(options))

  let label = formattedPrice
  let text = formattedPrice
  if (options.interval) {
    label += ` per ansatt, per ${options.interval === 'yearly' ? 'år' : 'måned'}`
    text += `/${options.interval === 'yearly' ? 'år' : 'mnd.'}`
  }

  let suffix: string

  if (options.taxIncluded) {
    label += ' inkludert '
    suffix = ' inkl. '
  }
  else {
    label += ' ekskludert '
    suffix = ' ekskl. '
  }

  label += 'merverdiavgift'
  suffix += 'mva.'

  return { label, text, suffix }
}
